app.controller("VacationAddController", [
    "$scope", "$uibModalInstance", "params", "StaticData", "DocumentsService", "toastr", "Hr", "ConfirmModal",
    function ($scope, $uibModalInstance, params, StaticData, DocumentsService, toastr, Hr, ConfirmModal) {
        $scope.vacation = {};
        $scope.chosenEmployee = "";
        $scope.chosenActor = null;
        $scope.params = params;

        if (params.vacation) {

            $scope.chosenEmployee = params.vacation.profile;
            if ($scope.chosenEmployee) {
                $scope.chosenEmployee.positionInfo = params.vacation.positionInfo;
                if (params.vacation.actingPositionInfo) {
                    $scope.chosenActor = {
                        _id: params.vacation.actingPositionInfo.actorPosition.profile,
                        user: params.vacation.actingPositionInfo.actorPosition.user,
                        positionInfo: {
                            organization: params.vacation.actingPositionInfo.actorPosition.organization,
                            position: params.vacation.actingPositionInfo.actorPosition.position,
                        }
                    };
                }
            }

            $scope.vacation = {
                startDate: new Date(params.vacation.startDate),
                endDate: new Date(params.vacation.endDate),
                comment: params.vacation.comment,
                document: params.vacation.document,
                _id: params.vacation._id
            }
        }

        if (params.doc) {
            $scope.chosenEmployee = params.doc.author;
            $scope.vacation = {
                startDate: null,
                endDate: null,
                comment: null,
                document: params.doc._id,
                _id: null
            }
        }

        $scope.action = 'დამატება';
        if (params.action === 'edit') {
            $scope.action = 'რედაქტირება';
        }
        $scope.popup1 = {
            opened: false
        };

        $scope.popup2 = {
            opened: false
        };

        $scope.openCalendar = function (key) {
            $scope[key].opened = true;
        };

        $scope.showForm = function (e) {
            return typeof $scope.chosenEmployee === 'object';
        };

        $scope.getEmployees = function (name) {
            if (name.length < 1) {
                return [];
            }
            return DocumentsService.staffList({
                query: name
            }).then(function (data) {
                return data.docs;
            });
        };

        $scope.save = function () {
            $scope.vacation.profile = $scope.chosenEmployee._id;
            $scope.vacation.chosenActor = $scope.chosenActor ? $scope.chosenActor._id : null;
            Hr.addVacation($scope.vacation).then(function () {
                $uibModalInstance.close();
            }).catch(function (err) {
                if (err.status === 400) {
                    toastr.error('', 'დაფიქსირდა შეცდომა: ' + err.data.error);
                }
            });
        };

        $scope.cancel = function () {
            ConfirmModal.show({
                title: "შვებულების წაშლა",
                message: "გსურთ  წაშალოთ ჩანაწერი სიიდან?"
            }).result.then(function () {
                $scope.vacation.status = 0;
                Hr.addVacation($scope.vacation).then(function () {
                    $uibModalInstance.close();
                }).catch(function (err) {
                    if (err.status === 400) {
                        toastr.error('', 'დაფიქსირდა შეცდომა: ' + err.data.error);
                    }
                });
            });
        };


        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
